<app-modal-frame
  [headerText]="CONSTS.HEADER"
  [rightButton]="{
    type: BUTTON_TYPES.REPORT_BUTTON,
  }"
  (emitExit)="onExit()"
  (emitRightClick)="getReport()"
>
  <div class="report-on-road-operation">
      <form [formGroup]="sendAgainForm" class="form-wrapper">
    <ion-row>
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12" >
          <app-form-select
            [label]="CONSTS.ROUTE"
            [options]="routes"
            [customClass]="'scan-type-dropdown report-select'"
            formControlName="route"
          >
          </app-form-select>
        </ion-col>
        <ion-col size="12" size-sm="6" size-md="6" size-lg="6" size-xl="12">
          <app-report-format
            [radioButtonValue]="sendAgainForm.get('reportFormat')?.value"
            (emitRadioChange)="radioChange($event)"
          ></app-report-format>
        </ion-col>
    </ion-row>
      </form>
    <app-download-note [numRows]="'2,000'"> </app-download-note>
  </div>
</app-modal-frame>
<app-pdf-report-generator
  #pdfContainer
  [hidden]="true"
  [columns]="PDF_REPORT.COLUMNS"
  [columnsData]="sendAgainReport"
  [dataFields]="PDF_REPORT.DATA_FIELDS"
  [columnWidths]="[85, 155, 50, 115, 130, 140, 60]"
>
  <ng-container sub-header>
    <table
      aria-hidden="true"
      class="pdf-sub-header-table"
    >
      <tr class="pdf-sub-header-row">
        <td>
          {{ PDF_REPORT.HEADER.DRIVER }}
        </td>
        <td>
          {{ driver }}
        </td>
      </tr>
    </table>
  </ng-container>
</app-pdf-report-generator>
